// extracted by mini-css-extract-plugin
export default {"footnote":"app-performanceReviews-PerformanceReviewSingle-module__LIgkSYpMgHFzv89G7zQE"};